import { render, staticRenderFns } from "./MaterialBrand.vue?vue&type=template&id=3ff6f43c&"
import script from "./MaterialBrand.vue?vue&type=script&lang=js&"
export * from "./MaterialBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports